import script from "./hardware-warning.vue?vue&type=script&lang=ts&setup=true"
export * from "./hardware-warning.vue?vue&type=script&lang=ts&setup=true"

import "./hardware-warning.vue?vue&type=style&index=0&id=172172d6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172172d6"]])

export default __exports__